import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function PrivacyPage() {
  return (
    <>
      <SEO
        title="Política de privacidad | Imalandia"
        description="Consulta cómo Imalandia trata los datos personales relacionados con pedidos, contacto y compras de productos personalizados."
        canonical={`${SITE_URL}/privacidad`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">PRIVACIDAD</p>

          <h1>POLÍTICA DE PRIVACIDAD</h1>

          <div className="legal-content">

            <p>Última actualización: 15 de abril de 2026</p>

            <h3>1. Responsable del tratamiento</h3>

            <p>
              En cumplimiento de lo dispuesto en la normativa aplicable en
              materia de protección de datos personales, imalandia.com y correo
              electrónico de contacto info@imalandia.com, es el responsable
              del tratamiento de los datos personales recabados a través del
              sitio web imalandia.com (en adelante, el “Sitio Web”).
            </p>

            <h3>2. Datos personales que recopilamos</h3>

            <p>Podemos tratar las siguientes categorías de datos personales:</p>

            <p>- Datos identificativos: nombre y apellidos.</p>

            <p>
              - Datos de contacto: correo electrónico, teléfono y dirección
              postal.
            </p>

            <p>
              - Datos de envío y facturación: dirección de entrega, dirección de
              facturación, país, provincia y código postal.
            </p>

            <p>
              - Datos relacionados con la compra: productos adquiridos, importe,
              fecha del pedido, incidencias, devoluciones y reclamaciones.
            </p>

            <p>
              - Datos de comunicaciones: información facilitada a través de
              formularios de contacto o por correo electrónico.
            </p>

            <p>
              - Datos técnicos de navegación, cuando corresponda, para el
              correcto funcionamiento del Sitio Web.
            </p>

            <h3>3. Finalidades del tratamiento</h3>

            <p>Tratamos los datos personales con las siguientes finalidades:</p>

            <p>- Gestionar pedidos, pagos, envíos y entregas.</p>

            <p>- Tramitar devoluciones, cambios, garantías y reclamaciones.</p>

            <p>
              - Atender consultas, solicitudes o comunicaciones enviadas por el
              usuario.
            </p>

            <p>
              - Cumplir obligaciones legales, fiscales, contables y
              administrativas.
            </p>

            <p>
              - Mejorar la experiencia de usuario y el funcionamiento del Sitio
              Web.
            </p>

            <p>
              - Prevenir fraudes y garantizar la seguridad de las transacciones.
            </p>

            <h3>4. Base jurídica del tratamiento</h3>

            <p>
              La base legal para el tratamiento de los datos personales puede
              ser:
            </p>

            <p>
              - La ejecución de un contrato o la aplicación de medidas
              precontractuales.
            </p>

            <p>- El cumplimiento de obligaciones legales.</p>

            <p>
              - El interés legítimo del responsable para garantizar la
              seguridad, prevenir el fraude y mejorar sus servicios.
            </p>

            <p>
              - El consentimiento del interesado cuando resulte legalmente
              exigible.
            </p>

            <h3>5. Conservación de los datos</h3>

            <p>
              Los datos personales se conservarán durante el tiempo necesario
              para cumplir con la finalidad para la que fueron recabados y,
              posteriormente, durante los plazos legalmente exigidos para
              atender posibles responsabilidades derivadas del tratamiento.
            </p>

            <h3>6. Destinatarios de los datos</h3>

            <p>
              Los datos personales podrán ser comunicados a terceros únicamente
              cuando sea necesario para la correcta prestación del servicio,
              tales como:
            </p>

            <p>
              - Proveedores de servicios de pago, para la gestión segura de los
              cobros con tarjeta.
            </p>

            <p>
              - Empresas de transporte y logística para la entrega de los
              pedidos.
            </p>

            <p>
              - Proveedores tecnológicos de alojamiento web y servicios
              relacionados con el funcionamiento del Sitio Web.
            </p>

            <p>En ningún caso se venderán datos personales a terceros.</p>

            <h3>7. Transferencias internacionales</h3>

            <p>
              Si alguno de los proveedores utilizados realizara tratamientos
              fuera del Espacio Económico Europeo, se adoptarán las garantías
              adecuadas exigidas por la normativa aplicable.
            </p>

            <h3>8. Derechos de los usuarios</h3>

            <p>
              El usuario puede ejercer en cualquier momento sus derechos de
              acceso, rectificación, supresión, oposición, limitación del
              tratamiento y portabilidad, mediante solicitud enviada a
              joseramon@imalandia.com, indicando en el asunto “Protección de
              datos” y acreditando debidamente su identidad.
            </p>

            <p>
              Asimismo, si considera que el tratamiento de sus datos personales
              no se ajusta a la normativa vigente puede presentar una
              reclamación ante la autoridad de control competente en España.
            </p>

            <h3>9. Seguridad de los datos</h3>

            <p>
              El responsable del tratamiento aplica medidas técnicas y
              organizativas apropiadas para garantizar un nivel de seguridad
              adecuado y proteger los datos personales frente a pérdida, acceso
              no autorizado, alteración o divulgación indebida.
            </p>

            <h3>10. Cookies</h3>

            <p>
              Este Sitio Web no utiliza cookies de análisis, publicidad o
              seguimiento. Únicamente podrán emplearse, en su caso, cookies o
              tecnologías estrictamente necesarias para el correcto
              funcionamiento del sitio y del proceso de compra.
            </p>

            <h3>11. Menores de edad</h3>

            <p>
              Los servicios de este Sitio Web no están dirigidos a menores de
              edad. Si detectamos que se han facilitado datos de menores sin la
              debida autorización procederemos a su eliminación cuando
              corresponda.
            </p>

            <h3>12. Modificaciones de la política</h3>

            <p>
              Nos reservamos el derecho a modificar la presente Política de
              Privacidad para adaptarla a novedades legislativas o cambios en el
              Sitio Web. La versión publicada será siempre la vigente.
            </p>

            <p>
              Contacto: Para cualquier consulta relacionada con esta Política de
              Privacidad puede escribir a joseramon@imalandia.com.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
